<template>
  <div class="comp-sidenav">
    <el-scrollbar
      ref="bar"
      wrap-class="scrollbar-wrapper"
      style="height:100%"
      :wrap-style="{ overflow: 'auto' }"
    >
      <!-- 滚动条包裹部分 -->
      <router-link
        v-for="(item, key) in items"
        :key="key"
        draggable="false"
        :to="getLink(item.path)"
      >
        <div
          class="link-content"
          @mouseenter="mouseenterLink(item)"
          @mouseleave="mouseleaveLink()"
        >
          <div class="link-iconUrl">
            <img
              :src="$.handleAssetsUrl(item.iconUrl)"
              alt=""
            >
          </div>
          <!-- <i
            class="icon-wrapper"
            :style="{ ...iconStyles[key] }"
          >
            <iconfont
              :name="'#icon' + item.icon"
              font-size="18px"
            ></iconfont>
          </i> -->
          <span
            draggable="false"
            class="view-name"
          >{{ item.text }}</span>
        </div>
      </router-link>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tinycolor from 'tinycolor2';

export default {
  data() {
    return {
      iconStyles: {}
      // lists: []
    };
  },
  computed: {
    ...mapGetters({
      items: 'views/dict'
    })
  },
  created() {
    window.addEventListener('resize', () => {
      this.$refs.bar.update();
    });
  },
  mounted() {
    // this.$nextTick(function() {
    //   this.onGetList();
    // });
    this.updateIconStyles();
  },
  methods: {
    // ...mapMutations({
    //   setDict: 'views/setDict'
    // }),
    // async onGetList() {
    //   console.log('items===>', this.items);
    //   this.lists = this.items;
    //   let result = await this.$http.get('/common/applications');
    //   for (const key in this.lists) {
    //     for (let index = 0; index < result.data.data.length; index++) {
    //       const t = result.data.data[index];
    //       if (t.appName === this.lists[key].text) {
    //         Object.assign(this.lists[key], t);
    //       }
    //     }
    //   }
    //   this.setDict(this.lists);
    //   this.$forceUpdate();
    // },
    updateIconStyles(name) {
      let rPath = this.$route.path;
      let dict = {};
      Object.entries(this.items).forEach(([k, v]) => {
        let colors = v.bgc && v.bgc.split(' ');
        let background = colors ? `linear-gradient(142deg, ${colors[0]} 0%, ${colors[1]} 100%)` : '';
        let boxShadow = 'none';
        if (k === name || '/' + k === rPath) {
          let color = tinycolor(colors[0]);
          color.setAlpha(0.25);
          let colorStr = color.toString();
          boxShadow = colors ? `0px 5px 14px 0px ${colorStr}` : '';
        }
        dict[k] = {
          background,
          boxShadow
        };
      });
      this.iconStyles = dict;
    },
    mouseenterLink(item) {
      let name = (item.path || '').slice(1);
      this.updateIconStyles(name);
    },
    mouseleaveLink() {
      this.updateIconStyles();
    },
    getLink(path) {
      let { id: video, fileType } = this.$route.query;
      if (video === 'undefined') {
        video = '';
      }
      if (fileType === 'undefined') {
        fileType === '';
      }
      let query = '';
      if (video) {
        query += 'id=' + video;
      }
      if (fileType) {
        if (query) {
          query += '&';
        }
        query += 'fileType=' + fileType;
      }
      if (query) {
        path += '?' + query;
      }
      return path;
    }
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
.comp-sidenav {
  width: 197px;
  padding-top: 17px;
  flex-shrink: 0;

  a {
    width: 197px;
    height: 84px;
    font-weight: bold;
    color: #2c3e50;
    padding: 10px 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #62668d;
    display: flex;
    justify-content: center;
    align-items: center;
    transition-duration: 0.3s;
    & > i {
      color: #fff;
    }

    &:hover {
      & > span {
        color: #2f58fe;
        font-weight: bold;
      }
    }

    &.router-link-exact-active,
    &.router-link-active {
      //background: #f6f7fb;
      background-color: rgba(246, 247, 251, 0.6);
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      & > .link-content > span {
        color: #2f58fe;
        font-weight: bold;
      }
      & .icon-wrapper,
      .link-iconUrl {
        overflow: hidden;
        border-radius: 8px;
        transform: scale(calc(44 / 34));
        box-shadow: 0px 5px 14px 0px rgba(15, 37, 126, 0.251);
      }
    }
  }
}
.icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  // background-color: red;
  margin-right: 25px;
  transition-duration: 0.3s;
  img {
    width: 100%;
    width: 100%;
  }
}
.view-name {
  min-width: 50px;
}
.link-content {
  width: 100%;
  height: 100%;
  font-weight: bold;
  color: #2c3e50;
  padding: 10px 0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #62668d;
  display: flex;
  justify-content: center;
  align-items: center;
  transition-duration: 0.3s;
  .link-iconUrl {
    width: 36px;
    height: 36px;
    margin-right: 29px;
    img {
      width: 100%;
      width: 100%;
    }
  }
  & > i {
    color: #fff;
  }
  &:hover {
    & > span {
      color: #2f58fe;
      font-weight: bold;
    }
  }
}
</style>
<style lang="scss">
.comp-sidenav .scrollbar-wrapper {
  overflow: auto;
}
</style>
